import React from 'react';
import { Button, Typography, Stack, colors, Container, Breadcrumbs, Link } from '@mui/material';
import _ from 'lodash';
import toast from 'react-hot-toast';
import AddUserDialog from './AddUserDialog.js';
import DialogLoading from '../../components/DialogLoading.js';
import Cookies from 'universal-cookie';
import PortalHeader from '../portal/PortalHeader.js';
import { decode } from 'jsonwebtoken';
import { fetchWith401Check } from '../../helpers/http.js';

function NotificationPage({ userInfo }) {
  const [loadingProps, setLoadingProps] = React.useState({ show: false, title: 'Loading ...', description: 'Please wait' });
  const [dialogProps, setDialogProps] = React.useState({ show: false, type: '', title: '', description: '', metadata: {} });
  const cookies = new Cookies();
  const decoded = decode(cookies.get('token'));

  const [iframeURL, setIframeURL] = React.useState('');

  const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

  const getURL = () => {
    fetchWith401Check(`${API_URL}/dashboard/comments`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
      body: JSON.stringify({ created_by: decoded.username }),
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const url = response.response;
        setIframeURL(url);
      })
      .catch(function (err) {
        return toast.error(err.message || 'Something wrong happenned');
      });
  };

  React.useEffect(() => {
    getURL();
  }, []);

  return (
    <Stack sx={{ backgroundColor: colors.grey[100] }}>
      <Container sx={{ backgroundColor: colors.grey[50] }}>
        <Stack direction='column' sx={{ height: '100vh' }} p={2} spacing={2}>
          <Stack direction='row' spacing={4} alignItems='center'>
            <Breadcrumbs aria-label='breadcrumb'>
              <Link underline='hover' color='inherit' href='/portal'>
                Home
              </Link>
              <Typography color='text.primary'>Comments</Typography>
            </Breadcrumbs>
          </Stack>
          <PortalHeader userInfo={userInfo} />
          <iframe src={iframeURL} frameborder='0' width='100%' height='100%' allowtransparency></iframe>
          <AddUserDialog dialogProps={dialogProps} setDialogProps={setDialogProps} />
          <DialogLoading props={loadingProps} />
        </Stack>
      </Container>
    </Stack>
  );
}

export default NotificationPage;
